import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsDashboardsDetailsPageEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-assets-dashboards-details-entrypoint" */ './index.tsx').then(
			(module) => module.AssetsDashboardsDetails,
		),
	),
	getPreloadProps: () => ({}),
});
